import React from "react";
import { QuoteIcon } from "lucide-react";
import { testimonials } from "../../data/testimonials";
export function TestimonialsSection() {
  const [featured, ...others] = testimonials;
  return <section className="w-full bg-paper py-20 md:py-28" data-id="element-173" data-mp="1oonv3rp7immi">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-174" data-mp="1oq8pnhbiu5kd">
        <h2 className="max-w-2xl text-4xl font-semibold leading-[1.05] tracking-tight text-ink md:text-5xl" data-id="element-175" data-mp="1sqshq6h8mizn">
          Ils nous ont confié leur maison
        </h2>

        <div className="mt-14 grid gap-6 lg:grid-cols-12" data-id="element-176" data-mp="2le56mnavf2w4">
          <figure className="flex flex-col rounded-2xl bg-white p-8 md:p-12 lg:col-span-7" data-id="element-177" data-mp="2ldn1t2a57gcl">
            <QuoteIcon className="h-10 w-10 text-lime" fill="#D4F36B" aria-hidden="true" data-id="element-178" data-mp="27mi8ehxdbkap" />
            <blockquote className="mt-6 text-2xl font-medium leading-snug tracking-tight text-ink md:text-[28px]" data-id="element-179" data-mp="2bnahnb68pp6z">
              « {featured.quote} »
            </blockquote>
            <figcaption className="mt-auto pt-10" data-id="element-180" data-mp="34562v3klwkbz">
              <p className="font-semibold text-ink" data-id="element-181" data-mp="3470qipn9iqjr">{featured.name}</p>
              <p className="text-sm text-muted" data-id="element-182" data-mp="15lka4lns7j1i">{featured.context}</p>
            </figcaption>
          </figure>

          <div className="grid gap-6 lg:col-span-5" data-id="element-183" data-mp="10nivqe1aw7wd">
            {others.map(t => <figure key={t.name} className="flex flex-col rounded-2xl border border-ink/10 p-7" data-id="element-184" data-mp="1fc6ne980zxh1">
                <blockquote className="text-lg leading-relaxed text-ink" data-id="element-185" data-mp="1aiatbhuvuur5">« {t.quote} »</blockquote>
                <figcaption className="mt-auto pt-6" data-id="element-186" data-mp="1o9padj58clvk">
                  <p className="font-semibold text-ink" data-id="element-187" data-mp="1k9ymbn738juq">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-188" data-mp="1kbrp2rekyjxg">{t.context}</p>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}